'use client';

import Header from '@/components/common/Header';
import GolfCourseHubInteractive from './components/GolfCourseHubInteractive';

export default function GolfCourseHubPage() {
  return (
    <>
      <Header />
      <GolfCourseHubInteractive />
    </>
  );
}
